module.exports = __webpack_public_path__ + "img/symbol_12_normal.7642f1ab.png";